
import { Component, Vue, Prop } from 'vue-property-decorator';
import { LoadingTemplateType } from './enums/LoadingTemplateType';
import {
  LoadingListAvatarTwoLines,
  LoadingListCard,
  LoadingOrdineDettaglio,
  LoadingLavorazioneDettaglio,
  LoadingCreaSpedizione,
  LoadingConsumi,
  LoadingDistintaDettaglio,
  LoadingReintegroDettaglio,
  LoadingDataTable
} from './loading-templates';

@Component({
  components: {
    LoadingListAvatarTwoLines,
    LoadingListCard,
    LoadingOrdineDettaglio,
    LoadingLavorazioneDettaglio,
    LoadingCreaSpedizione,
    LoadingConsumi,
    LoadingDistintaDettaglio,    
    LoadingReintegroDettaglio,
    LoadingDataTable
  }
})
export default class Loading extends Vue {
  @Prop({ default: false }) visible!: boolean;
  @Prop({ default: '' }) private message!: string;
  @Prop() templateType!: LoadingTemplateType;

  private templates = LoadingTemplateType;
}
